import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Welcome from './pages/Welcome';
import TradingAccount from './pages/TradingAccount';
import PropFirmChallenge from './pages/PropFirmChallenge';
import Footer from './components/Footer';
import UpgradeOffer from './components/UpgradeOffer';
import { LeadboosterLoader } from './components/LeadboosterLoader';
import {LandingForm} from './components/LandingForm/LandingForm'

export default function App() {
  const excludedRoutes = ['/welcome', '/start', '/trading-account', '/discord'];
  const shouldShowChat = !excludedRoutes.includes(location.pathname);
  
  const excludedHeaderRoutes = ['/discord', '/trading-account'];
  const shouldShowHeader = !excludedHeaderRoutes.includes(location.pathname);

  return (
    <Router>
      <div className="min-h-screen bg-black">
        {shouldShowHeader &&<Header />}

        {shouldShowChat && <LeadboosterLoader />}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/trading-account" element={<TradingAccount />} />
          <Route path="/propfirm-challenge" element={<PropFirmChallenge />} />
          <Route path="/start" element={<UpgradeOffer />} />
          <Route path="/discord" element={<LandingForm />} />

        </Routes>
        { <Footer />}
      </div>
    </Router>
  );
}